// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';           // updated import
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "./pages/AuthContext";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));   // createRoot 

root.render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <AuthProvider>
    <App />
  </AuthProvider>
  </BrowserRouter>
);
